<template>
  <LayoutMainPage :class="['cock-fight-body', { mobile: isMobile, freeze: isAnyPopupOpen }]" :style="maxWidthStyle">
    <section
      class="container"
      :class="[getTheme(theme), { vertical: isMobileVertical, landscape: isMobileLandscape, sticky: isSticky }]"
      @scroll="handleScroll"
    >
      <div class="left-panel">
        <!-- Always mount one player so video-banner-wrapper (Banker vs Player) stays visible; loading overlay is inside .video-wrapper when !videoPlayerReady -->
        <VePlayerVideo
          v-if="isUsingVePlayer"
          :videoPlayerReady="videoPlayerReady"
          ref="vePlayer"
          :key="'veplayer'"
          :isAnyPopupOpen="isAnyPopupOpen"
          :class="{ 'sticky-video': isSticky && isFloatingVideo }"
          @playback-failed="onVePlayerPlaybackFailed"
        >
          <template #overlay>
            <VideoToast :toast="betVideoToast" :source="arena.id" />
          </template>
        </VePlayerVideo>
        <TCVideo
          v-else-if="!isUsingV1Video"
          :videoPlayerReady="videoPlayerReady"
          ref="tcVideo"
          :key="'tcvideo'"
          :isAnyPopupOpen="isAnyPopupOpen"
          :class="{ 'sticky-video': isSticky && isFloatingVideo }"
        >
          <template #overlay>
            <VideoToast :toast="betVideoToast" :source="arena.id" />
          </template>
        </TCVideo>
        <TCVideoV1
          v-else
          :videoPlayerReady="videoPlayerReady"
          ref="tcVideoV1"
          :key="'tcvideov1'"
          :isAnyPopupOpen="isAnyPopupOpen"
          :class="{ 'sticky-video': isSticky && isFloatingVideo }"
        >
          <template #overlay>
            <VideoToast :toast="betVideoToast" :source="arena.id" />
          </template>
        </TCVideoV1>
        <GameStatus
          class="game-status-mobile"
          :active="hasUncollectTicket"
          @jackpotCollectPopup="collectJackpotHandler"
          @jackpotPhysicalPopup="openMenuPopup(PopupPage.jackpotPhysicalHelp)"
        />
        <template v-if="!isMobile || isMobileLandscape">
          <Charts v-if="chartFights && chartFights.length > 0" />
        </template>
      </div>
      <div class="right-panel">
        <Notifications v-if="isMobileLandscape || !isMobile" />
        <BetPanel
          :active="hasUncollectTicket"
          @jackpotCollectPopup="collectJackpotHandler"
          @jackpotPhysicalPopup="openMenuPopup(PopupPage.jackpotPhysicalHelp)"
        />
        <div class="footer-landscape-wrapper" v-if="isMobileLandscape">
          <FooterLandscape />
        </div>
        <template v-if="isMobile && !isMobileLandscape">
          <Charts v-if="chartFights && chartFights.length > 0" />
        </template>
      </div>
    </section>
    <MenuPopup />
    <Popup
      ref="jackpotCollectPopup"
      :active="isJackpotCollectionPopupOpen"
      @close="isJackpotCollectionPopupOpen = false"
      animation="fade"
      :transparentBg="false"
      :fullsize="false"
      :hasBg="false"
      :align="isMobile ? 'center' : 'right'"
      :borderRadiusBySide="['16px', '16px', '16px', '16px']"
      v-bind="{
        modalContainerStyles: defaultJackpotCollectionContainerStyle,
      }"
    >
      <JackPotCollectionPopup @jackpotPopup="jackpotHandler" />
    </Popup>
    <Popup
      ref="jackpotPopup"
      :active="isJackpotPopupOpen"
      @close="toggleJackpotClose"
      animation="fade"
      :transparentBg="false"
      :fullsize="false"
      :align="'right'"
      :valign="'bottom'"
      :hasBg="false"
      :showHeader="true"
      :borderRadiusBySide="isMobile ? ['16px', '16px', '0', '0'] : ['16px', '0', '0', '16px']"
      v-bind="{
        modalContainerStyles: defaultContainerStyle('jackpot'),
      }"
    >
      <template v-slot:modalHeader>
        <div class="modal-header-wrapper">
          <Nav :imageURL="activePopupPage" :toURL="toURL" :popupLevel="popupLevel(activePopupPage)">
            {{ $t(activePopupPage) }}
          </Nav>
          <div v-if="activePopupPage === PopupPage.jackpot" class="jackpot-nav-btns" :class="{ 'is-mobile': isMobile }">
            <img src="@/assets/images/jackpot-history.svg" @click="updateActivePopupPage(PopupPage.jackpotHistory)" />
            <img
              src="@/assets/images/jackpot-instant-prize.svg"
              v-if="config.enableJackpot"
              @click="updateActivePopupPage(PopupPage.jackpotHelp)"
            />
          </div>
          <div class="close-btn" v-if="!isMobile" @click="toggleJackpotClose">
            <img src="@/assets/images/close.webp" />
          </div>
        </div>
      </template>
      <JackPotPopup v-if="activePopupPage === PopupPage.jackpot" />
      <JackpotLogs
        v-if="activePopupPage === PopupPage.jackpotHistory"
        :logTickets="ownerPayoutTicketsLog"
        :ticketsLength="ownerTicketsLog.length || 0"
        hasHeader
        @loadMoreTickets="getOwnerTicketsLog"
      />
      <HelpContent v-if="activePopupPage === PopupPage.jackpotHelp" :helpSource="luckyDrawInstantPrizeHelpGuide" />
    </Popup>
    <Popup
      ref="errorPopup"
      :active="isErrorPopupOpen"
      @close="toggleErrorPopupClose"
      animation="fade"
      :transparentBg="false"
      :fullsize="false"
      :hasBg="false"
      :align="isMobile ? 'center' : 'right'"
      :borderRadiusBySide="['16px', '16px', '16px', '16px']"
      v-bind="{
        modalContainerStyles: defaultErrorMessageStyle,
      }"
    >
      <ErrorAlert @hidePopup="toggleErrorPopupClose" />
    </Popup>
  </LayoutMainPage>
</template>

<script>
import FooterLandscape from '@/components/footer-landscape.vue';
import Notifications from '@/components/notification';
import VideoWrapper from '@/components/video-wrapper';
import TCVideo from '@/components/tc-video.vue';
import TCVideoV1 from '@/components/tc-video-v1.vue';
import VePlayerVideo from '@/components/ve-player.vue';
import VideoToast from '@/components/tai-xiu/video-toast.vue';
import BetPanel from '@/components/bet-panel';
import GameStatus from '@/components/bet-panel/game-status.vue';
import Charts from '@/components/charts/index.vue';
import Popup from '@/components/popup/index.vue';
import MenuPopup from '@/components/menus/menu-popup.vue';
import JackPotCollectionPopup from '@/components/popup/jackpot-collect.vue';
import JackPotPopup from '@/components/popup/jackpot.vue';
import { mapActions, mapGetters } from 'vuex';
import { PopupPage, FightStatus, Orientation } from '@/utils/index.model';
import { isMobile, isIOS } from 'mobile-device-detect';
import LayoutMainPage from '@/layouts/main-page.vue';
import { some, findLast } from 'lodash';
import { getImgUrl } from '@/utils/helpers';
import Nav from '@/components/menus/nav.vue';
import HelpContent from '@/components/help/index.vue';
import JackpotLogs from '@/components/jackpot/ticket-logs.vue';
import ErrorAlert from '@/components/popup/error-alert.vue';
import { JACKPOT_HELP_GUIDE, getLuckyDrawInstantPrizeHelpGuide } from '@/utils/game-help.ts';
import { initMgConnection } from '@/utils/websocket';
import { GC_ALERT_LOG_TYPE } from '@/utils/constant';

export default {
  components: {
    LayoutMainPage,
    VideoWrapper,
    TCVideo,
    TCVideoV1,
    VideoToast,
    VePlayerVideo,
    BetPanel,
    GameStatus,
    Charts,
    FooterLandscape,
    Notifications,
    Popup,
    MenuPopup,
    JackPotCollectionPopup,
    JackPotPopup,
    Nav,
    HelpContent,
    ErrorAlert,
    JackpotLogs,
  },
  data() {
    return {
      PopupPage,
      isMobile,
      isIOS,
      isJackpotCollectionPopupOpen: false,
      showErrorPopup: false,
      JACKPOT_HELP_GUIDE,
      jackpotInterval: null,
      isSticky: false,
      videoOffsetTop: 0,
      videoDocTop: 0,
      // Idle detection for metrics logging
      idleTimeout: null,
      idleInterval: null,
      lastActivityTime: Date.now(),
      IDLE_TIMEOUT_MS: 30 * 60 * 1000, // 30 minutes in milliseconds
      useV1VideoPlayer: isIOS,
      mobileVePlayerFallback: false,
      videoPlayerReady: true,
      isFirstIOSPlayerSwitch: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.resetBalance();
      vm.getWallet();
      vm.getArenas();
      vm.getJackpots();
      vm.updateAnnouncement();
      vm.updateGeneral({
        constrols: {
          historySelection: '',
        },
      });
    });
  },
  created() {
    this.jackpotInterval = setInterval(
      () =>
        this.getOwnerTickets({
          isSeen: false,
        }),
      120000
    );
  },
  mounted() {
    if (this.arena.id) {
      this.getFights();
      this.getFightsForChart(this.arena.currentMatchDayId);
    }

    // Set up metrics logging (debug screen, right-click, idle detection)
    this.setupMetricsLogging();

    // Add scroll listener for floating video on mobile (both V1 and regular video)
    this.$nextTick(() => {
      const container = this.$el.querySelector('.container');
      if (container && this.isFloatingVideo && isMobile) {
        this.captureVideoOffset();
        container.addEventListener('scroll', this.handleScroll);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
      }
    });

    this.videoPlayerReady = false;
    // Re-evaluate after mount: on refresh, arena.id may already be set so the watcher ran
    // before mounted; switchIOSVideoPlayer here ensures we hide loading once player type is stable.
    this.$nextTick(() => {
      this.switchIOSVideoPlayer(this.streamWatermarkData.watermark);
    });
  },

  beforeDestroy() {
    const container = this.$el.querySelector('.container');
    if (container && this.isFloatingVideo && isMobile) {
      container.removeEventListener('scroll', this.handleScroll);
    }
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    ...mapGetters({
      isPopupOpen: 'menu/isPopupOpen',
      isJackpotPopupOpen: 'menu/isJackpotPopupOpen',
      activePopupPage: 'menu/activePopupPage',
      isErrorPopupOpen: 'menu/isErrorPopupOpen',
      errorMsg: 'menu/errorMsg',
      token: 'general/token',
      arena: 'general/selectedArena',
      arenas: 'general/arenas',
      config: 'general/config',
      withCommission: 'general/withCommission',
      streamVersion: 'general/streamVersion',
      streamWatermarkData: 'general/streamWatermarkData',
      theme: 'general/theme',
      member: 'general/member',
    }),
    ...mapGetters('fight', ['fight', 'chartFights']),
    ...mapGetters('bets', { betVideoToast: 'videoToast' }),
    ...mapGetters('jackpot', [
      'ownerTickets',
      'lastLuckyDraw',
      'ownerTicketsLog',
      'currentLuckyDraw',
      'currentInstantPrize',
      'ownerLuckyDrawTickets',
      'ownerInstantPrizeTickets',
    ]),
    ...mapGetters('general', ['token', 'oddsType', 'config']),

    luckyDrawInstantPrizeHelpGuide() {
      return getLuckyDrawInstantPrizeHelpGuide(this.config.taxPercent, this.config.language);
    },
    effectiveStreamVersion() {
      const version = Number(this.streamVersion);
      // No / unknown streamv defaults to 3 (VePlayer).
      return [1, 2, 3].includes(version) ? version : 3;
    },
    isUsingVePlayer() {
      if (isMobile && this.mobileVePlayerFallback) return false;

      // streamv=3 (and the default): VePlayer on every device.
      return this.effectiveStreamVersion === 3;
    },
    isUsingV1Video() {
      if (this.isUsingVePlayer) return false;
      if (isMobile && this.mobileVePlayerFallback) return true;

      // streamv=1: TCPlayer on every device.
      // streamv=2: TCPlayer only on iOS; Android/Desktop use canvas.
      return this.effectiveStreamVersion === 1 || (isMobile && isIOS && this.effectiveStreamVersion === 2);
    },

    videoComponentKey() {
      if (this.isUsingVePlayer) return 'video-veplayer';
      return `video-${this.isUsingV1Video}`;
    },

    isFloatingVideo() {
      return this.config.floatVideo;
    },
    ownerPayoutTicketsLog() {
      return this.ownerTicketsLog.filter(
        (t) =>
          (t.jackpot.type === 1 && t.rebate > 0) ||
          (t.jackpot.type === 0 && t.luckyDrawWinner && t.luckyDrawWinner.amount)
      );
    },
    isAnyPopupOpen() {
      return this.isPopupOpen || this.isJackpotCollectionPopupOpen || this.isJackpotPopupOpen;
    },
    toURL() {
      switch (this.activePopupPage) {
        case PopupPage.limits:
        case PopupPage.history:
        case PopupPage.statement:
        case PopupPage.help:
        case PopupPage.settings:
        case PopupPage.notification:
        case PopupPage.schedule:
          return isMobile ? '' : PopupPage.main;
        case PopupPage.betDetail:
          return PopupPage.history;
        case PopupPage.tnc:
          return PopupPage.help;
        case PopupPage.main:
        case PopupPage.jackpot:
        case PopupPage.jackpotPhysicalHelp:
          return '';
        case PopupPage.jackpotHistory:
        case PopupPage.jackpotLuckyDraw:
          return PopupPage.jackpot;
        case PopupPage.scheduleDetail:
          return PopupPage.schedule;
        case PopupPage.jackpotHelp:
          return isMobile
            ? ''
            : this.isPopupOpen
            ? ''
            : PopupPage.jackpot;
        default:
          return '';
      }
    },
    isMobileLandscape() {
      return isMobile && this.$screen.orientation === Orientation.landscape;
    },
    isMobileVertical() {
      return isMobile && this.$screen.orientation === Orientation.portrait;
    },
    hasUncollectTicket() {
      // Going to update
      return some(this.ownerTickets, (ticket) => ticket.seenByMember === false);
    },
    uncollectLuckyDrawId() {
      const uncollectLuckyDraw = findLast(this.ownerLuckyDrawTickets, (ticket) => ticket.seenByMember === false);
      return uncollectLuckyDraw ? uncollectLuckyDraw.id : '';
    },
    uncollectInstantPrizeId() {
      const uncollectInstantPrize = findLast(this.ownerInstantPrizeTickets, (ticket) => ticket.seenByMember === false);
      return uncollectInstantPrize ? uncollectInstantPrize.id : '';
    },
    defaultJackpotCollectionContainerStyle() {
      const defaultStyle = {
        position: 'relative',
        width: '90%',
        maxWidth: '350px',
        height: '320px',
      };

      if (!isMobile) {
        defaultStyle.marginRight = '15%';
        defaultStyle.marginTop = '20%';
      }
      return defaultStyle;
    },
    defaultErrorMessageStyle() {
      const defaultStyle = {
        position: 'relative',
        width: '90%',
        maxWidth: '350px',
        height: '240px',
        justifyContent: 'center',
        alignItems: 'center',
      };

      if (!isMobile) {
        defaultStyle.marginRight = '15%';
        defaultStyle.marginTop = '20%';
      }
      return defaultStyle;
    },
    maxWidthStyle() {
      if (this.isMobile || this.$screen.height >= 850) return '';

      // return {
      //   'max-width': `${1400 * (this.$screen.height / 1000)}px`,
      // };
    },
  },
  methods: {
    ...mapActions('general', [
      'getWallet',
      'getArenas',
      'resetBalance',
      'updateGeneral',
      'stopArenaStreamPolling',
      'sendMetricsLog',
      'getArenaStreamUrl',
    ]),
    ...mapActions('menu', ['updateMenu']),
    ...mapActions('fight', ['getCurrentFight', 'getFightsForChart', 'resetFightsPage']),
    ...mapActions('bets', ['getMyBets', 'resetBetHistory', 'resetBetData', 'dropUnconfirmedBets']),
    ...mapActions('jackpot', [
      'getAvailableTickets',
      'getOwnerTickets',
      'updateTicketsSeenStatus',
      'getPastWinners',
      'getJackpots',
      'getProgressAmount',
      'resetTicketsPage',
      'getOwnerTicketsLog',
    ]),
    ...mapActions('ticket', ['resetTicketPage']),
    ...mapActions('announcement', ['updateAnnouncement']),
    ...mapActions('schedule', ['updateSchedules']),
    getImgUrl,

    onVePlayerPlaybackFailed() {
      if (!isMobile || this.mobileVePlayerFallback) return;
      this.mobileVePlayerFallback = true;
      this.videoPlayerReady = false;
      this.$nextTick(() => {
        this.videoPlayerReady = true;
        this.switchIOSVideoPlayer(this.streamWatermarkData.watermark);
      });
    },

    // Metrics logging methods
    setupMetricsLogging() {
      // Set up idle detection (anti-inspect callback is set in main.ts)
      this.setupIdleDetection();
    },

    setupIdleDetection() {
      // Reset activity time on user interactions
      const resetActivity = () => {
        this.lastActivityTime = Date.now();
      };

      const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
      activityEvents.forEach((event) => {
        document.addEventListener(event, resetActivity, { passive: true });
      });

      this._activityCleanup = () => {
        activityEvents.forEach((event) => {
          document.removeEventListener(event, resetActivity);
        });
      };

      // Check for idle every minute
      this.idleInterval = setInterval(() => {
        const now = Date.now();
        const idleTime = now - this.lastActivityTime;

        if (idleTime >= this.IDLE_TIMEOUT_MS) {
          // User has been idle for 30 minutes
          this.sendMetricsLog(GC_ALERT_LOG_TYPE.IDLE_30_MIN);
          // Reset the activity time so it will trigger again in another 30 min if still idle
          this.lastActivityTime = now;
        }
      }, 60000); // Check every minute
    },

    cleanupMetricsLogging() {
      // Clean up idle detection
      if (this.idleInterval) {
        clearInterval(this.idleInterval);
        this.idleInterval = null;
      }

      // Clean up activity event listeners
      if (this._activityCleanup) {
        this._activityCleanup();
        this._activityCleanup = null;
      }
    },

    // Switch iOS video player with transition to avoid race condition
    switchIOSVideoPlayer(watermark) {
      const shouldUseV1 = !watermark || watermark === '';
      if (this.useV1VideoPlayer === shouldUseV1) {
        if (!this.videoPlayerReady) {
          this.videoPlayerReady = true;
        }
        return;
      }

      // On first load, switch synchronously (no delay) to avoid blocking video mount
      if (this.isFirstIOSPlayerSwitch) {
        this.isFirstIOSPlayerSwitch = false;
        this.useV1VideoPlayer = shouldUseV1;
        return;
      }

      // Prevent concurrent switches (debounce rapid arena changes)
      if (this._switchTimer) {
        clearTimeout(this._switchTimer);
        this._switchTimer = null;
      }

      this.videoPlayerReady = false;
      this.$nextTick(() => {
        this._switchTimer = setTimeout(() => {
          this._switchTimer = null;
          this.useV1VideoPlayer = shouldUseV1;
          this.$nextTick(() => {
            setTimeout(() => {
              this.videoPlayerReady = true;
            }, 500); // Increased from 200ms - Chrome iOS needs more time to release video decoders
          });
        }, 300);
      });
    },

    /*
     * Where the player sits before it floats. Which player is on screen depends
     * on currency and OS -- ve-player, Tencent, or the v1 Tencent -- and only
     * the two Tencent refs were ever read, so with ve-player active (the
     * default on this build) the offset stayed 0 and the video never floated.
     */
    captureVideoOffset() {
      const player = this.$refs.vePlayer || this.$refs.tcVideo || this.$refs.tcVideoV1;
      if (player && player.$el) this.videoOffsetTop = player.$el.offsetTop;
      // Embedded in the Tai Xiu page the container has no fixed height, so it
      // grows to its content and the document scrolls instead of the container.
      const container = this.$el && this.$el.querySelector('.container');
      if (container) this.videoDocTop = container.getBoundingClientRect().top + window.scrollY;
    },

    handleScroll() {
      if (!this.isFloatingVideo || !isMobile) return;

      const container = document.querySelector('.container');
      if (!container) return;

      if (!this.isSticky) this.captureVideoOffset();

      this.isSticky =
        container.scrollTop > this.videoOffsetTop || window.scrollY > this.videoDocTop + this.videoOffsetTop;
    },
    popupLevel(page) {
      if (isMobile && page !== PopupPage.jackpot && page !== PopupPage.jackpotPhysicalHelp) return 2;
      if (
        [
          PopupPage.tnc,
          PopupPage.betDetail,
          PopupPage.jackpotHistory,
          PopupPage.jackpotLuckyDraw,
          PopupPage.scheduleDetail,
        ].includes(page)
      )
        return 2;
      if (this.isJackpotPopupOpen && page === PopupPage.jackpotHelp) return 2;

      return 1;
    },
    getFights() {
      // const { dayStart, dayEnd } = this.getDateRange();
      this.getCurrentFight({
        arena_id: this.arena.id,
        // from_confirmed_date_time: dayStart,
        // to_confirmed_date_time: dayEnd,
      });
    },
    collectJackpotHandler() {
      if (this.hasUncollectTicket) {
        this.isJackpotCollectionPopupOpen = true;
      } else {
        // Need to test jackpot collect will have wallet or not
        // setTimeout(() => this.getWallet(), 5000);
        this.getProgressAmount();
        this.resetTicketsPage();
        this.getPastWinners();
        this.getOwnerTicketsLog();
        if (this.currentLuckyDraw && this.currentLuckyDraw.id) {
          this.getOwnerTickets({
            id: this.currentLuckyDraw.id,
            type: 'current-lucky-draw',
            isSeen: true,
          });
        }
        if (this.lastLuckyDraw && this.lastLuckyDraw.id) {
          this.getOwnerTickets({
            id: this.lastLuckyDraw.id,
            type: 'past-lucky-draw',
            isSeen: true,
          });
        }
        this.isJackpotCollectionPopupOpen = false;
        this.updateMenu({
          activePopupPage: PopupPage.jackpot,
          isJackpotPopupOpen: true,
        });
      }
    },
    async jackpotHandler() {
      // Need to be udpated
      this.isJackpotCollectionPopupOpen = false;
      let luckyDrawUpdateReady = true;
      let instentUpdateReady = true;
      if (this.uncollectLuckyDrawId) {
        luckyDrawUpdateReady = false;
        luckyDrawUpdateReady = await this.updateTicketsSeenStatus(this.uncollectLuckyDrawId).then(() =>
          Promise.resolve(true)
        );
      }
      if (this.uncollectInstantPrizeId) {
        instentUpdateReady = false;
        instentUpdateReady = await this.updateTicketsSeenStatus(this.uncollectInstantPrizeId).then(() =>
          Promise.resolve(true)
        );
      }
      if (luckyDrawUpdateReady && instentUpdateReady) {
        this.getOwnerTickets({
          isSeen: false,
        }).then(() => setTimeout(() => this.collectJackpotHandler(), 300));
      }
    },
    toggleJackpotClose() {
      this.updateMenu({
        isJackpotPopupOpen: false,
      });
    },
    toggleErrorPopupClose() {
      this.updateMenu({
        isErrorPopupOpen: false,
        errorMsg: '',
      });
    },
    updateActivePopupPage(page) {
      this.updateMenu({
        activePopupPage: page,
      });
    },
    openMenuPopup(page) {
      this.updateMenu({ isPopupOpen: true, isJackpotPopupOpen: false, activePopupPage: page });
    },
    defaultContainerStyle(popup) {
      const defaultStyle = {
        position: 'relative',
        minWidth: '45%',
        maxWidth: '45%',
      };

      if (this.isMobileVertical) {
        return {
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          minWidth: '100%',
          maxWidth: '100%',
          height: 'calc(100% - 320px)',
          minHeight: '524px',
          maxHeight: 'calc(100dvh - 80px)',
        };
      }
      if (this.isMobileLandscape) {
        return {
          position: 'relative',
          minWidth: '45%',
          maxWidth: '45%',
          height: '100% ',
        };
      }
      switch (popup) {
        case 'menu':
          defaultStyle.height = 'calc(100% - 180px)';
          break;
        case 'jackpot':
          defaultStyle.height = '600px';
          defaultStyle.marginTop = this.$screen.height > 800 ? '130px' : '90px';
          break;
        case 'help':
          defaultStyle.height = 'calc(100% - 180px)';
          defaultStyle.minWidth = '90%';
          defaultStyle.maxWidth = '90%';
          break;
      }
      return defaultStyle;
    },

    switchIOSVideoPlayer(watermark) {
      const shouldUseV1 = !watermark || watermark === '';
      if (this.useV1VideoPlayer === shouldUseV1) {
        if (!this.videoPlayerReady) {
          this.videoPlayerReady = true;
        }
        return;
      }
      // Player type differs (e.g. iOS with watermark uses canvas): still ready to show
      // the correct player (isUsingV1Video already reflects this); hide loading overlay.
      if (!this.videoPlayerReady) {
        this.videoPlayerReady = true;
      }
    },
    getTheme(theme) {
      switch (theme) {
        case 'world-cup':
          return 'theme-world-cup';
        default:
          return '';
      }
    },
  },
  watch: {
    // Watch for streamWatermarkData changes to trigger iOS video player switch
    streamWatermarkData: {
      handler(newVal) {
        // Skip the immediate call with empty/default data - the initial state is already
        // set correctly in data() so we don't need to trigger a switch on mount
        if (this.isFirstIOSPlayerSwitch && (!newVal || !newVal.url)) return;
        this.switchIOSVideoPlayer(newVal.watermark);
      },
      deep: true,
      immediate: true,
    },
    'config.language': {
      handler(newVal) {
        if (!newVal) return;
        this.updateAnnouncement();
        this.updateSchedules();
      },
    },
    /*
     * The toggle can be flipped after the page has mounted, and the listener
     * was only ever attached in `mounted` when it happened to be on -- so
     * turning it on mid-session did nothing until a reload.
     */
    isFloatingVideo(enabled) {
      const container = this.$el && this.$el.querySelector('.container');
      if (!container || !isMobile) return;
      if (enabled) {
        this.captureVideoOffset();
        container.addEventListener('scroll', this.handleScroll);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
      } else {
        container.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('scroll', this.handleScroll);
        this.isSticky = false;
      }
    },
    'arena.id': {
      handler(newVal, oldVal) {
        if (!newVal) return;
        if (isMobile) {
          this.mobileVePlayerFallback = false;
        }
        if (oldVal && oldVal !== newVal) this.stopArenaStreamPolling(oldVal);
        this.getFights();
        this.getFightsForChart(this.arena.currentMatchDayId);
        initMgConnection(this.token, this.oddsType);
        // Request stream URL early so it's ready when the video component mounts
        this.getArenaStreamUrl(newVal);
        // Reset iOS video player state when arena changes
        this.switchIOSVideoPlayer(this.streamWatermarkData.watermark);
      },
      immediate: true,
    },
    'fight.id': {
      handler(newVal) {
        if (!newVal) return;
        this.getMyBets(newVal);
      },
      immediate: true,
    },
    'currentLuckyDraw.id': {
      handler(newVal) {
        if (!newVal) return;
        this.getAvailableTickets(newVal);
      },
      immediate: true,
    },
    'fight.status': {
      handler(newVal, oldVal) {
        if (!newVal) {
          this.resetBetData();
          this.resetBetHistory();
        } else if (FightStatus[newVal] >= 3) {
          // Betting closed: unsent chips are dropped, with a pill on the video.
          this.dropUnconfirmedBets();
        }
        if (FightStatus[newVal] >= 7 || newVal === 'processing') {
          setTimeout(() => {
            this.getFightsForChart(this.fight.matchDay.id);
          }, 15000);
        }
      },
      immediate: true,
      deep: true,
    },
    activePopupPage(newVal) {
      switch (newVal) {
        case 'history':
          this.resetTicketPage();
          break;
        case 'results':
          this.resetFightsPage();
          break;
      }
    },
    '$screen.visibility': {
      handler(isVisible, oldVal) {
        if (isVisible && oldVal === false) {
          this.getJackpots();
          if (this.arena.id) this.getFights();
        }
      },
    },
  },
  destroyed() {
    clearInterval(this.jackpotInterval);
    this.stopArenaStreamPolling();
    // Clean up metrics logging
    this.cleanupMetricsLogging();
    // Clean up video player switch timer
    if (this._switchTimer) {
      clearTimeout(this._switchTimer);
      this._switchTimer = null;
    }
  },
};
</script>

<style lang="scss">
.cock-fight-body {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  max-width: 1400px;
  margin: auto;
  position: relative;

  &.mobile {
    &.freeze {
      overflow: hidden;
    }

    & .container {
      height: 100%;
      .left-panel {
        max-width: 50%;
        width: 50%;
        margin-right: 0;
      }

      .right-panel {
        max-width: 50%;
        width: 50%;
        margin-left: 0;
      }
    }
  }

  .container {
    width: 100%;
    height: calc(100% - 90px);
    margin: 0 auto;
    padding: 4px;
    padding-bottom: 0;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    box-sizing: border-box;
    background-image: url('~@/assets/images/cf_bg.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: right bottom;
    background-color: #0a0d14;
    overflow-y: auto;

    &.theme-world-cup {
      background-image: url('~@/assets/images/worldcup-bg.webp');
      background-size: cover;

      &.vertical {
        background-image: url('~@/assets/images/worldcup-bg-mobile.webp');
        background-position: center;
      }
    }

    .left-panel {
      display: flex;
      flex-direction: column;
      max-width: 49%;
      width: 49%;

      .sticky-video {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 9990;
      }

      .game-status-mobile {
        display: none;
      }

      margin-right: 1%;
    }

    .right-panel {
      display: flex;
      max-width: 49%;
      width: 49%;
      margin-left: 1%;

      flex-direction: column;
      justify-content: flex-start;

      .footer-landscape-wrapper {
        width: 50%;
        height: 48px;
        display: flex;
        position: absolute;
        bottom: 2px;
        right: 0;
      }
    }

    &.sticky {
      padding: 250px 0 0 0;
    }

    &.vertical {
      height: calc(100% - 72px);
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;
      overflow-y: auto;
      overflow-x: hidden;
      // v2.1: the video, its bar and the betting 10px in from the edges, 8 apart.
      padding: 8px 10px 30px;
      background-color: #061820;

      &.sticky {
        // Padding top should match the video height (16:9 aspect ratio)
        // 100vw * 9/16 = 56.25vw
        padding-top: calc(56.25vw + 8px);
      }

      .left-panel {
        width: 100%;
        max-width: 100%;
        display: block;
        margin-bottom: 8px;

        // The player's top corners; the status bar under it carries the bottom ones.
        > :first-child:not(.sticky-video) {
          border-radius: 12px 12px 0 0;
          overflow: hidden;
        }

        .sticky-video {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: auto;
          z-index: 9990;
        }

        // v2.1: the 28px bar under the video.
        .game-status-mobile {
          display: flex;
          height: 28px;
          min-height: 28px;
          max-height: 28px;
          padding: 0 6px 0 12px;
          border-radius: 0 0 12px 12px;
          background-image: $ga-info-bar-bg;

          .status-text {
            font-size: 13px;
            font-weight: 700;
          }

          .jackpot-btn-wrapper .jackpot-physical-btn {
            height: 20px;
          }

          .jackpot-btn-wrapper .jackpot-btn {
            height: 20px;
            margin-right: 0;
            background-image: $ga-grad-gold;

            img {
              width: 16px;
              height: 16px;
            }

            .text {
              color: $ga-text-on-gold;
              font-size: 10.5px;
            }
          }
        }
      }

      .right-panel {
        width: 100%;
        max-width: 100%;
        display: block;
      }
    }
  }

  .chart-box {
    margin-top: 16px;
  }

  .temp-arena-toggle-btns.active {
    background-color: blue;
  }

  .modal-header-wrapper {
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    justify-content: flex-start;

    .jackpot-nav-btns {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 50px;

      &.is-mobile {
        margin-right: 0;
      }

      img {
        width: 24px;
        height: 24px;
        margin-left: 8px;
        cursor: pointer;
      }
    }

    .close-btn {
      width: 32px;
      height: 32px;
      position: absolute;
      right: 0;
      top: 0;
      display: block;
      background-image: linear-gradient(358deg, #bcbfc3 99%, #f0f0f0 1%);
      border-radius: 52%;
      cursor: pointer;

      img {
        width: 14px;
        height: 14px;
        margin: 9px;
      }
    }
  }
}
</style>
